/* ==========================================================================
   Vex Ecom · Holy Looks — carrinho e cross-sell nativos.

   Substitui o app de cross-sell por codigo:
   - barra de frete gratis ($75) + regua de quantidade (2=10%, 3=15%, 5+=25%)
     no topo da gaveta do carrinho e da pagina de carrinho;
   - "Complete the look" na pagina de produto e na gaveta, usando a API
     nativa de recomendacao da Shopify (/recommendations/products.json),
     que ja devolve resultado bom nesta loja e nao custa mensalidade.

   Referencia de linguagem: lissen.com.br, que faz o combo na propria pagina.
   ========================================================================== */
(function () {
  'use strict';

  var FRETE_GRATIS = 7500;                                  // centavos
  var DEGRAUS = [{ min: 2, off: 10 }, { min: 3, off: 15 }, { min: 5, off: 25 }];

  // Ultimo /cart.js lido. Existe porque a gaveta e redesenhada pelo tema em
  // momentos que nao sao os nossos -- ver `ligarOlhoGaveta()` -- e reinjetar a
  // barra exige ter os numeros em maos na hora, sem esperar outra requisicao.
  var ultimoCarrinho = null;

  function dinheiro(centavos) {
    return '$' + (centavos / 100).toFixed(2);
  }

  function pegarCarrinho() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function escapar(txt) {
    return String(txt == null ? '' : txt)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* ---------------------------------------------------------------- barra */

  function montarBarra() {
    var el = document.createElement('div');
    el.className = 'vex-cart-bar';
    el.setAttribute('data-vex-cart-bar', '');
    el.innerHTML =
      '<p class="vex-cart-bar__frase" data-frase></p>' +
      '<div class="vex-cart-bar__trilho"><div class="vex-cart-bar__preenche" data-preenche></div></div>' +
      // Sem rotulo, os tres degraus eram tres pares de numeros soltos: quem
      // nunca viu a oferta nao tinha como saber que "3 · 15%" e um desconto
      // por quantidade. O rotulo fica na mesma linha, à esquerda, para nao
      // virar uma terceira frase na barra.
      '<p class="vex-cart-bar__olho">Buy more, save more</p>' +
      '<ol class="vex-cart-bar__degraus">' +
        DEGRAUS.map(function (d) {
          return '<li class="vex-cart-bar__degrau" data-min="' + d.min + '">' +
                 (d.min === 5 ? '5+' : d.min) + ' &middot; <b>' + d.off + '%</b></li>';
        }).join('') +
      '</ol>';
    return el;
  }

  function pintarBarra(carrinho) {
    var total = carrinho.total_price || 0;
    var qtd = carrinho.item_count || 0;
    var falta = Math.max(0, FRETE_GRATIS - total);
    var pct = Math.min(100, (total / FRETE_GRATIS) * 100);

    document.querySelectorAll('[data-vex-cart-bar]').forEach(function (barra) {
      barra.classList.toggle('vex-cart-bar--completo', falta === 0);
      barra.querySelector('[data-preenche]').style.width = pct + '%';
      barra.querySelector('[data-frase]').innerHTML = falta === 0
        ? 'You unlocked <b>FREE</b> shipping'
        : 'You are <b>' + dinheiro(falta) + '</b> away from <b>FREE</b> shipping';
      barra.querySelectorAll('.vex-cart-bar__degrau').forEach(function (li) {
        li.classList.toggle('is-ativo', qtd >= parseInt(li.dataset.min, 10));
      });
    });
  }

  // O botao ganha o total (como no app que estava antes) e os selos de
  // pagamento entram embaixo dele.
  function enfeitarFinalizar(carrinho) {
    document.querySelectorAll('.cart-drawer__inner .cart__checkout-button').forEach(function (b) {
      // O `· $102.00` e escrito por esta funcao. Quando o tema redesenha a
      // gaveta, o texto ja pode vir com o preco dentro -- capturar isso como
      // base produzia "CHECK OUT · $102.00 · $120.00" no clique seguinte.
      var base = b.dataset.vexBase ||
        (b.dataset.vexBase = b.textContent.trim().replace(/\s*·\s*\$[\d.,]+\s*$/, ''));
      b.textContent = base + ' · ' + dinheiro(carrinho.total_price || 0);
    });

    var fonte = document.querySelector('.vex-pagamentos-fonte');
    var ctas = document.querySelector('.cart-drawer__inner .cart__ctas');
    if (fonte && ctas && !ctas.querySelector('.vex-pagamentos')) {
      var copia = fonte.firstElementChild.cloneNode(true);
      ctas.appendChild(copia);
    }
  }

  function encaixarBarra() {
    // gaveta: dentro do dialog, nunca no componente raiz (esse vive no cabecalho
    // e e renderizado mesmo fechado, o que jogava a barra em cima do menu)
    var alvos = [
      document.querySelector('.cart-drawer__inner'),
      document.querySelector('main cart-items-component')
    ];
    alvos.forEach(function (alvo) {
      if (!alvo || alvo.querySelector('[data-vex-cart-bar]')) return;
      alvo.insertBefore(montarBarra(), alvo.firstChild);
    });
  }

  /* ==================================================================
     A GAVETA E REFEITA A CADA MUDANCA NO CARRINHO, E LEVAVA A BARRA JUNTO.
     BUG ENCONTRADO EM 22/09.

     `assets/component-cart-items.js` chama, depois de todo add/change/remove:

         morphSection('cart-drawer-section', html, { mode: 'hydration' })

     No modo `hydration` o alvo do morph e o no marcado com
     `data-hydration-key`, e em `snippets/cart-drawer.liquid` esse no e
     exatamente a `.cart-drawer__inner` -- o mesmo elemento onde a barra e
     injetada. O HTML que volta do servidor nao conhece a barra, entao o morph
     a apaga. O mesmo vale para os selos de pagamento, que vivem dentro de
     `.cart__ctas`, tambem filha da `.cart-drawer__inner`.

     Era isto que a cliente via e descreveu como "so aparece depois de
     navegar": no primeiro acesso ela adicionava um produto, a gaveta abria
     SEM a barra de frete e SEM os selos, e so na pagina seguinte -- render
     novo, script rodando do zero -- as duas coisas voltavam. Os unicos
     ganchos que existiam eram dois temporizadores (120ms depois do fetch de
     carrinho, 350ms depois de um clique qualquer), e o morph acontece depois
     deles.

     Com o carrinho VAZIO o buraco era ainda maior: sem itens o tema nao
     imprime `.cart__ctas`, entao nao havia onde pendurar os selos, e a
     primeira adicao caia no caso acima.

     A correcao e observar a gaveta e reinjetar assim que ela se redesenha,
     em vez de tentar adivinhar o tempo do tema.
     ================================================================== */
  var olhoGaveta = null;
  var reaplicaAgendada = null;
  var ultimaReaplicacao = 0;

  function aplicarNaGaveta() {
    encaixarBarra();
    // O "Complete the look" da gaveta mora dentro da mesma
    // `.cart-drawer__inner` e ia embora pelo mesmo motivo. So e refeito
    // quando sumiu de fato e ha o que sugerir -- as travas de assinatura
    // dentro de `encaixarLook` cuidam do resto.
    var gaveta = document.querySelector('.cart-drawer__inner');
    if (gaveta && !gaveta.querySelector('[data-vex-look]') &&
        ultimoCarrinho && ultimoCarrinho.item_count > 0) {
      encaixarLook();
    }
    if (!ultimoCarrinho) return;
    pintarBarra(ultimoCarrinho);
    enfeitarFinalizar(ultimoCarrinho);
  }

  function reaplicar() {
    if (reaplicaAgendada) return;
    // Piso de tempo alem do quadro: um carregamento de imagem ou um bloco de
    // app que entre na gaveta tambem acorda o observador, e sem o piso uma
    // rajada desses viraria uma reinjecao por mutacao.
    var espera = Math.max(0, 200 - (Date.now() - ultimaReaplicacao));
    reaplicaAgendada = window.setTimeout(function () {
      reaplicaAgendada = null;
      ultimaReaplicacao = Date.now();
      // DESLIGAR ANTES DE ESCREVER. `enfeitarFinalizar` escreve no botao de
      // finalizar e `encaixarBarra` insere um elemento -- os dois dentro do
      // que esta sendo observado. Sem o disconnect, cada reinjecao chamaria o
      // observador de volta, em laco infinito.
      if (olhoGaveta) olhoGaveta.disconnect();
      try { aplicarNaGaveta(); } catch (e) {}
      ligarOlhoGaveta();
    }, espera);
  }

  function ligarOlhoGaveta() {
    var gaveta = document.getElementById('cart-drawer');
    if (!gaveta || typeof MutationObserver !== 'function') return;
    if (!olhoGaveta) olhoGaveta = new MutationObserver(reaplicar);
    // So `childList`: as classes que o tema liga e desliga durante o
    // carregamento (`cart-items-disabled`, shimmer) sao atributos, e observar
    // atributos aqui seria acordar a cada animacao por nada.
    olhoGaveta.observe(gaveta, { childList: true, subtree: true });
  }

  /* ----------------------------------------------------------- cross-sell */

  function primeiraDisponivel(p) {
    for (var i = 0; i < p.variants.length; i++) if (p.variants[i].available) return p.variants[i];
    return p.variants[0];
  }

  // As URLs de imagem da Shopify quase sempre ja vem com `?v=`, mas nao e
  // garantido -- em imagem de variante recem-enviada o parametro pode faltar,
  // e ai um `&width=` colado direto vira lixo na query e a foto nao carrega.
  function comLargura(url, largura) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + largura;
  }

  // Carrossel compacto para a gaveta: cabe mais produto em menos altura.
  // Na pagina de produto o formato e outro -- ver `montarBundle`.
  //
  // ADICIONAR AO CARRINHO PELO CAMINHO DO PROPRIO TEMA.
  //
  // O QUE ESTAVA ERRADO ATE 04/09, e por que a cliente disse que o botao
  // "nao funcionava": o item ENTRAVA no carrinho, mas nada acontecia na tela.
  // Eu chamava `/cart/add.js` e trocava na mao o `cart-items-component` da
  // gaveta pelo HTML devolvido. Duas consequencias:
  //
  //   1. A GAVETA NAO ABRIA. No Horizon quem abre e o `cart-drawer-component`,
  //      e ele so abre ao ouvir o evento `shopify:cart:lines-update` com
  //      `action: 'add'` (ver assets/cart-drawer.js). Sem o evento, o clique
  //      ficava mudo: sem gaveta, sem confirmacao, cara de botao quebrado.
  //   2. A TROCA NA MAO BRIGAVA COM O TEMA. `cart-items-component` guarda
  //      referencias internas e espera ser atualizado por `morphSection`.
  //      Um `replaceWith` cru descarta esse estado.
  //
  // AGORA O CAMINHO E O MESMO DO BOTAO NATIVO. Antes do fetch eu disparo o
  // evento padrao com uma PROMESSA em aberto; o tema se inscreve nela. Quando
  // a resposta chega, resolvo a promessa com as seções que a Shopify
  // devolveu, e daí em diante quem redesenha a lista, o total, o desconto e o
  // contador da sacola -- e quem abre a gaveta -- e o proprio tema.
  //
  // As secoes pedidas sao as de TODOS os `cart-items-component` da pagina
  // (gaveta e, na pagina do carrinho, a lista principal), lidas do atributo
  // `data-section-id`. Leio o atributo e nao a propriedade `sectionId`: o
  // getter do tema LANCA excecao quando o atributo esta vazio, e uma excecao
  // aqui mataria o clique inteiro em silencio.
  function adicionarAoCarrinho(itens) {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });

    var corpo = { items: itens };
    if (ids.length) {
      corpo.sections = ids.join(',');
      corpo.sections_url = window.location.pathname;
    }

    // A promessa que o tema acompanha. Precisa existir ANTES do disparo.
    var resolver, rejeitar, jaFechou = false;
    var promessa = new Promise(function (ok, falha) {
      resolver = function (v) { if (!jaFechou) { jaFechou = true; ok(v); } };
      rejeitar = function (e) { if (!jaFechou) { jaFechou = true; falha(e); } };
    });
    // Sem isto, um erro fecha a promessa sem ninguem escutando e o navegador
    // registra "unhandled rejection" no console do cliente.
    promessa.catch(function () {});

    // Evento padrao da Shopify, montado a mao: este arquivo e script classico
    // e nao consegue importar o modulo `@shopify/events` do tema. O tema le
    // apenas `action`, `target` e `promise`, que e o que vai aqui.
    var aviso = new Event('shopify:cart:lines-update', { bubbles: true });
    aviso.action = 'add';
    aviso.context = 'product';
    aviso.lines = itens.map(function (i) {
      return { merchandiseId: 'gid://shopify/ProductVariant/' + i.id, quantity: i.quantity };
    });
    aviso.promise = promessa;
    document.dispatchEvent(aviso);

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corpo)
    })
      .then(function (r) {
        return r.json().then(function (dados) { return { ok: r.ok, dados: dados }; });
      })
      .then(function (res) {
        // A Shopify responde 422 com `description` quando a variante acabou ou
        // nao pode ser vendida. Antes eu resolvia mesmo assim e o botao dizia
        // "Added" sobre uma falha -- pior que nao funcionar, porque mente.
        if (!res.ok || (res.dados && (res.dados.status >= 400 || res.dados.errors))) {
          var msg = (res.dados && (res.dados.description || res.dados.message)) || 'cart/add falhou';
          throw new Error(msg);
        }

        // ==============================================================
        // A CONTAGEM PRECISA IR JUNTO. BUG ENCONTRADO EM 22/09.
        //
        // O `cart-icon.js` do tema le assim:
        //     cart?.totalQuantity ?? detail?.itemCount ?? 0
        // Eu resolvia com `cart: null` e sem `itemCount` -- os dois primeiros
        // davam `undefined` e sobrava o ZERO. Ou seja: cada compra pelo combo
        // ESCONDIA a bolha do carrinho em vez de atualiza-la, e ainda gravava
        // "0" no sessionStorage, que o proprio tema relê nos 10 segundos
        // seguintes. Era por isso que a quantidade so aparecia depois de
        // recarregar a pagina umas vezes.
        //
        // `/cart/add.js` devolve so os itens ADICIONADOS, nunca o total do
        // carrinho -- daí a leitura do /cart.js antes de resolver. O custo e
        // uma requisicao curta, e ela tambem alimenta o cache que redesenha a
        // barra de frete e os selos de pagamento.
        // ==============================================================
        return pegarCarrinho().then(function (c) {
          ultimoCarrinho = c;
          resolver({
            cart: { totalQuantity: c.item_count },
            detail: {
              sections: res.dados.sections,
              items: res.dados.items,
              itemCount: c.item_count,
              source: 'vex-bundle',
              didError: false
            }
          });
          atualizar();
          return res.dados;
        });
      })
      .catch(function (erro) {
        rejeitar(erro);
        console.warn('[vex] falha ao adicionar ao carrinho:', erro && erro.message);
        throw erro;
      });
  }

  function montarCarrossel(produtos) {
    var caixa = document.createElement('div');
    caixa.className = 'vex-look vex-look--carrinho vex-look--carrossel';
    caixa.setAttribute('data-vex-look', '');

    var cards = produtos.map(function (p) {
      var v = primeiraDisponivel(p);
      var foto = p.featured_image || (p.images && p.images[0]) || '';
      var opcoes = p.variants.filter(function (x) { return x.available; });
      var seletor = opcoes.length > 1
        ? '<select class="vex-card__tam" data-variante>' + opcoes.map(function (o) {
            return '<option value="' + o.id + '" data-preco="' + o.price + '">' + escapar(o.title) + '</option>';
          }).join('') + '</select>'
        : '<input type="hidden" data-variante value="' + (v ? v.id : '') + '">';

      return '<li class="vex-card" data-item>' +
        '<a class="vex-card__foto" href="' + p.url + '">' +
          (foto ? '<img src="' + foto + '&width=260" alt="" loading="lazy">' : '') +
        '</a>' +
        '<a class="vex-card__nome" href="' + p.url + '">' + escapar(p.title) + '</a>' +
        '<span class="vex-card__preco">' + dinheiro(v ? v.price : p.price) + '</span>' +
        seletor +
        '<button type="button" class="vex-card__add" data-add>Add</button>' +
      '</li>';
    }).join('');

    caixa.innerHTML =
      '<p class="vex-look__titulo">Complete the look</p>' +
      '<ul class="vex-look__trilho">' + cards + '</ul>';

    caixa.addEventListener('click', function (ev) {
      var botao = ev.target.closest('[data-add]');
      if (!botao) return;
      var campo = botao.closest('[data-item]').querySelector('[data-variante]');
      var id = campo && campo.value;
      if (!id) return;
      botao.disabled = true;
      botao.textContent = 'Adding...';
      adicionarAoCarrinho([{ id: parseInt(id, 10), quantity: 1 }])
        .catch(function () { botao.disabled = false; botao.textContent = 'Add'; });
    });

    return caixa;
  }

  /* ------------------------------------------------- combo da pagina de produto

     UM BLOCO SO (01/09). Antes eram dois cartoes seguidos dizendo a mesma
     coisa: a regua "Buy more, save more" e, logo abaixo, o combo anunciando os
     mesmos 15%. Agora a regua e movida para o TOPO deste cartao -- ela continua
     viva (le o carrinho de verdade pelo script do vex-promo.liquid, que pinta
     todo `[data-vex-promo]` do documento) e deixa de repetir a oferta.

     SELECAO: gaveta propria, nao pastilhas e nao <select>. As pastilhas de
     tamanho quebravam em 3/2/1 num card estreito e desalinhavam os tres
     cartoes; o <select> abria uma lista desenhada pelo sistema operacional,
     que destoava do resto da loja. A gaveta e HTML comum e herda a mesma
     tipografia, o mesmo filete e as mesmas cores das outras caixas da pagina.
     Estilo em assets/vex-bundle.css.
     ------------------------------------------------------------------------ */

  // A regua que estava solta acima do combo. Se ainda nao foi clonada pelo
  // script do layout, clono aqui a partir da fonte escondida.
  function pegarRegua() {
    var regua = document.querySelector('.vex-promo--produto');
    if (regua) return regua;

    var fonte = document.querySelector('.vex-promo--fonte');
    if (!fonte) return null;

    regua = fonte.cloneNode(true);
    regua.classList.remove('vex-promo--fonte');
    regua.classList.add('vex-promo--produto');
    regua.removeAttribute('hidden');
    return regua;
  }

  function montarBundle(produtos) {
    var caixa = document.createElement('div');
    // a classe `vex-look` fica: as travas contra duplicidade do `encaixarLook`
    // procuram por ela.
    caixa.className = 'vex-look vex-bundle';
    caixa.setAttribute('data-vex-look', '');

    // desconto que a quantidade de pecas do combo ja destrava
    var offAlvo = 0;
    DEGRAUS.forEach(function (d) { if (produtos.length >= d.min) offAlvo = d.off; });

    var itens = produtos.map(function (p, indice) {
      var foto = p.featured_image || (p.images && p.images[0]) || '';
      var disponiveis = p.variants.filter(function (v) { return v.available; });
      var padrao = disponiveis[0] || p.variants[0];

      // So variantes disponiveis entram na lista: oferecer um tamanho
      // esgotado dentro de um combo e prometer o que nao se entrega.
      // O <select> nativo saiu daqui em 01/09. A caixa fechada ate aceita
      // estilo, mas a LISTA ABERTA quem desenha e o sistema operacional --
      // fundo branco, fonte do sistema, cantos do sistema. No meio de uma
      // loja inteira em maiuscula miuda com filete fino, ela aparecia como um
      // pedaco de outro site. A gaveta abaixo e HTML comum, entao segue as
      // mesmas cores, o mesmo filete e a mesma tipografia do resto da pagina.
      // O <input type=hidden> continua sendo a fonte da verdade da variante:
      // `varianteDe` le so ele, nos dois formatos.
      var seletor = disponiveis.length > 1
        ? '<div class="vex-bundle__gaveta" data-gaveta>' +
            '<button type="button" class="vex-bundle__gatilho" data-gatilho' +
              ' aria-expanded="false" aria-haspopup="listbox"' +
              ' aria-label="' + escapar(p.title) + '">' +
              '<span data-rotulo>' + escapar(padrao ? padrao.title : '') + '</span>' +
              '<svg viewBox="0 0 10 7" fill="none" aria-hidden="true" focusable="false">' +
                '<path d="M1 1.5 5 5.5 9 1.5" stroke="currentColor" stroke-width="1.2"/>' +
              '</svg>' +
            '</button>' +
            '<ul class="vex-bundle__opcoes" role="listbox" hidden>' +
              disponiveis.map(function (o, i) {
                return '<li class="vex-bundle__opcao' + (i ? '' : ' is-ativa') + '"' +
                  ' role="option" data-opcao data-id="' + o.id + '"' +
                  ' aria-selected="' + (i ? 'false' : 'true') + '">' +
                  escapar(o.title) +
                '</li>';
              }).join('') +
            '</ul>' +
            '<input type="hidden" data-variante value="' + (padrao ? padrao.id : '') + '">' +
          '</div>'
        : '<input type="hidden" data-variante value="' + (padrao ? padrao.id : '') + '">';

      return '<li class="vex-bundle__item" data-item data-indice="' + indice + '">' +
        '<button type="button" class="vex-bundle__foto" data-alternar aria-pressed="true"' +
          ' aria-label="' + escapar(p.title) + '">' +
          // `data-padrao` guarda a foto do PRODUTO. E para onde a imagem volta
          // quando a variante escolhida nao tem foto propria no admin.
          (foto ? '<img src="' + escapar(comLargura(foto, 520)) + '"' +
                  ' data-padrao="' + escapar(foto) + '" alt="" loading="lazy">' : '') +
          '<span class="vex-bundle__marca" aria-hidden="true"></span>' +
        '</button>' +
        '<a class="vex-bundle__nome" href="' + p.url + '">' + escapar(p.title) + '</a>' +
        '<span class="vex-bundle__preco" data-preco></span>' +
        seletor +
      '</li>';
    }).join('');

    caixa.innerHTML =
      '<p class="vex-bundle__olho">Complete the look</p>' +
      '<h3 class="vex-bundle__titulo">' +
        (offAlvo
          ? 'Choose ' + produtos.length + ' items and get ' + offAlvo + '% off'
          : 'Wear it together') +
      '</h3>' +
      // A grade rola na horizontal no celular. As setas ficam FORA dela,
      // no palco: dentro seriam recortadas pelo proprio `overflow-x`.
      '<div class="vex-bundle__palco">' +
        '<button type="button" class="vex-bundle__seta vex-bundle__seta--antes"' +
          ' data-vex-passo="-1" aria-label="Previous item">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"' +
            ' aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>' +
        '</button>' +
        '<ul class="vex-bundle__grade" data-grade>' + itens + '</ul>' +
        '<button type="button" class="vex-bundle__seta vex-bundle__seta--depois"' +
          ' data-vex-passo="1" aria-label="Next item">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"' +
            ' aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="vex-bundle__rodape">' +
        '<p class="vex-bundle__total">' +
          '<span class="vex-bundle__agora" data-agora></span>' +
          '<s class="vex-bundle__antes" data-antes></s>' +
        '</p>' +
        '<button type="button" class="vex-bundle__botao" data-adicionar></button>' +
      '</div>';

    // a regua entra como topo do cartao
    var regua = pegarRegua();
    if (regua) {
      regua.classList.add('vex-bundle__regua');
      caixa.insertBefore(regua, caixa.firstChild);
    }

    function varianteDe(li) {
      var p = produtos[parseInt(li.dataset.indice, 10)];
      var campo = li.querySelector('[data-variante]');
      var id = campo ? parseInt(campo.value, 10) : 0;
      var achada = null;
      p.variants.forEach(function (v) { if (v.id === id) achada = v; });
      return achada || primeiraDisponivel(p);
    }

    // A FOTO ACOMPANHA A VARIANTE ESCOLHIDA (pedido da cliente em 02/09).
    //
    // O JSON de /recommendations/products.json traz `featured_image` em cada
    // variante -- preenchido sempre que aquela variante tem imagem propria
    // atribuida no admin. Quando nao tem (o caso comum de tamanho, que nao
    // muda a foto), a imagem volta para a do produto, guardada em
    // `data-padrao`. Sem esse retorno, escolher um tamanho sem foto deixaria
    // o card vazio.
    function pintarFoto(li, v) {
      var img = li.querySelector('.vex-bundle__foto img');
      if (!img) return;
      var base = (v && v.featured_image && v.featured_image.src) || img.dataset.padrao;
      if (!base) return;
      var nova = comLargura(base, 520);
      // comparar antes de escrever: reatribuir o mesmo `src` faz o navegador
      // repintar a imagem, e a cada clique o card piscava.
      if (img.getAttribute('src') === nova) return;
      img.setAttribute('src', nova);
    }

    function recalcular() {
      var soma = 0, n = 0;

      caixa.querySelectorAll('[data-item]').forEach(function (li) {
        var v = varianteDe(li);
        pintarFoto(li, v);
        var alvo = li.querySelector('[data-preco]');
        if (alvo) alvo.textContent = dinheiro(v ? v.price : 0);
        if (li.classList.contains('is-fora')) return;
        soma += v ? v.price : 0;
        n++;
      });

      var off = 0;
      DEGRAUS.forEach(function (d) { if (n >= d.min) off = d.off; });

      var agora = caixa.querySelector('[data-agora]');
      var antes = caixa.querySelector('[data-antes]');
      var botao = caixa.querySelector('[data-adicionar]');

      if (!n) {
        agora.textContent = '';
        antes.textContent = '';
        botao.textContent = 'Add to cart';
        botao.disabled = true;
        return;
      }

      botao.disabled = false;
      botao.textContent = n === produtos.length
        ? 'Add all ' + n + ' to cart'
        : 'Add ' + n + ' to cart';

      if (off) {
        // Math.round e nao floor: com floor o total mostrado fica um centavo
        // abaixo do que a Shopify cobra, e um centavo de diferenca no
        // checkout e o tipo de coisa que faz o cliente desistir.
        agora.textContent = 'Now ' + dinheiro(Math.round(soma * (100 - off) / 100));
        antes.textContent = 'Was ' + dinheiro(soma);
      } else {
        agora.textContent = dinheiro(soma);
        antes.textContent = '';
      }
    }

    /* ------------------------------------------------ setas da grade

       A seta so existe quando a grade REALMENTE rola. Quem decide e a
       medida, nao a largura da tela: com dois produtos no combo, ou num
       celular largo, os tres cartoes cabem e a seta seria um botao morto.

       A folga de 4px absorve o arredondamento sub-pixel do navegador --
       sem ela `scrollWidth` fica 1px maior que `clientWidth` em telas com
       zoom e a seta aparece sem ter para onde ir. */
    var grade = caixa.querySelector('[data-grade]');
    var palco = caixa.querySelector('.vex-bundle__palco');

    function medirGrade() {
      if (!grade || !palco) return;
      var sobra = grade.scrollWidth - grade.clientWidth;
      palco.classList.toggle('is-rolavel', sobra > 4);
      var antes = palco.querySelector('[data-vex-passo="-1"]');
      var depois = palco.querySelector('[data-vex-passo="1"]');
      if (antes) antes.disabled = grade.scrollLeft <= 4;
      if (depois) depois.disabled = grade.scrollLeft >= sobra - 4;
    }

    var medidaAgendada = false;
    if (grade) {
      grade.addEventListener('scroll', function () {
        if (medidaAgendada) return;
        medidaAgendada = true;
        window.requestAnimationFrame(function () {
          medidaAgendada = false;
          medirGrade();
        });
      }, { passive: true });
    }
    window.addEventListener('resize', medirGrade, { passive: true });

    // Uma gaveta aberta por vez. Duas abertas ao mesmo tempo empurram o
    // rodape do combo para fora da tela no celular.
    function fecharGavetas(exceto) {
      caixa.querySelectorAll('[data-gaveta]').forEach(function (g) {
        if (g === exceto) return;
        g.classList.remove('is-aberta');
        g.querySelector('[data-gatilho]').setAttribute('aria-expanded', 'false');
        g.querySelector('.vex-bundle__opcoes').hidden = true;
      });
    }

    caixa.addEventListener('click', function (ev) {
      var seta = ev.target.closest('[data-vex-passo]');
      if (seta) {
        // Anda UM cartao, medido pela distancia real entre dois deles --
        // assim o passo continua certo se a largura da coluna mudar.
        var filhos = grade.children;
        var passo = filhos.length > 1
          ? filhos[1].getBoundingClientRect().left - filhos[0].getBoundingClientRect().left
          : grade.clientWidth;
        grade.scrollBy({
          left: passo * parseInt(seta.dataset.vexPasso, 10),
          behavior: 'smooth'
        });
        return;
      }

      var gatilho = ev.target.closest('[data-gatilho]');
      if (gatilho) {
        var gaveta = gatilho.closest('[data-gaveta]');
        var abrir = !gaveta.classList.contains('is-aberta');
        fecharGavetas(gaveta);
        gaveta.classList.toggle('is-aberta', abrir);
        gatilho.setAttribute('aria-expanded', abrir ? 'true' : 'false');
        gaveta.querySelector('.vex-bundle__opcoes').hidden = !abrir;
        return;
      }

      var opcao = ev.target.closest('[data-opcao]');
      if (opcao) {
        var dona = opcao.closest('[data-gaveta]');
        dona.querySelectorAll('[data-opcao]').forEach(function (o) {
          o.classList.remove('is-ativa');
          o.setAttribute('aria-selected', 'false');
        });
        opcao.classList.add('is-ativa');
        opcao.setAttribute('aria-selected', 'true');
        dona.querySelector('[data-variante]').value = opcao.dataset.id;
        dona.querySelector('[data-rotulo]').textContent = opcao.textContent;
        fecharGavetas(null);
        recalcular();
        return;
      }

      var alternar = ev.target.closest('[data-alternar]');
      if (!alternar) { fecharGavetas(null); return; }
      var item = alternar.closest('[data-item]');
      var fora = item.classList.toggle('is-fora');
      alternar.setAttribute('aria-pressed', fora ? 'false' : 'true');
      recalcular();
    });

    caixa.querySelector('[data-adicionar]').addEventListener('click', function () {
      var botao = this;
      var lista = [];
      caixa.querySelectorAll('[data-item]').forEach(function (li) {
        if (li.classList.contains('is-fora')) return;
        var v = varianteDe(li);
        if (v && v.available) lista.push({ id: v.id, quantity: 1 });
      });
      if (!lista.length) return;

      var rotulo = botao.textContent;
      botao.disabled = true;
      botao.textContent = 'Adding...';
      adicionarAoCarrinho(lista).then(function () {
        botao.textContent = 'Added';
        setTimeout(function () { botao.textContent = rotulo; botao.disabled = false; }, 1500);
      }).catch(function () {
        // Falha visivel. Voltar calado ao rotulo original faz o cliente
        // clicar de novo achando que errou a mira, e o motivo real (variante
        // esgotada, rede caida) fica so no console.
        botao.textContent = 'Try again';
        botao.disabled = false;
        setTimeout(function () {
          if (botao.textContent === 'Try again') botao.textContent = rotulo;
        }, 2500);
      });
    });

    caixa.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' || ev.key === 'Esc') fecharGavetas(null);
    });

    // Clique em qualquer outro lugar da pagina fecha. Precisa ser no
    // document: o clique fora do combo nunca chega ao listener de `caixa`.
    document.addEventListener('click', function (ev) {
      if (!caixa.contains(ev.target)) fecharGavetas(null);
    });

    recalcular();
    // `scrollWidth` so vale depois que o bloco esta na pagina e o navegador
    // fez o layout -- por isso num quadro seguinte, e nao aqui.
    window.requestAnimationFrame(medirGrade);
    return caixa;
  }

  var lookProdutoPedido = false;
  var lookGavetaEmVoo = null;   // assinatura de cesta em busca agora
  var lookGavetaVazio = null;   // assinatura que ja voltou sem sugestao

  function encaixarLook() {
    var idProduto = window.__vexProdutoId;

    // pagina de produto: logo abaixo do botao de compra.
    // A trava e SINCRONA. Antes a checagem acontecia antes do fetch terminar,
    // entao duas chamadas seguidas (DOMContentLoaded + load + clique) abriam
    // duas buscas e inseriam DOIS blocos.
    var compra = document.querySelector('.buy-buttons-block, .product-form-buttons');
    if (idProduto && compra && !lookProdutoPedido &&
        !document.querySelector('.vex-look:not(.vex-look--carrinho)')) {
      lookProdutoPedido = true;
      buscarCombo(idProduto, 3).then(function (ps) {
        if (!ps.length || document.querySelector('.vex-look:not(.vex-look--carrinho)')) return;
        // Ancorar DEPOIS dos blocos de entrega/frete que vem logo abaixo do
        // botao. Inserindo direto em `compra.nextSibling`, o combo entrava no
        // meio e empurrava "Estimated delivery" e a linha de frete para longe
        // do botao -- justamente a informacao que sustenta a decisao de
        // compra. Olha no maximo 3 irmaos para nao sair andando pela pagina
        // caso o template mude.
        var ancora = compra;
        var vizinho = compra.nextElementSibling;
        for (var i = 0; i < 3 && vizinho; i++) {
          if (/deliver|shipping|exchange|arrives|frete/i.test(vizinho.textContent || '')) ancora = vizinho;
          vizinho = vizinho.nextElementSibling;
        }
        ancora.parentElement.insertBefore(montarBundle(ps), ancora.nextSibling);
      }).catch(function () { lookProdutoPedido = false; });
    }

    // gaveta do carrinho: sugestao a partir do primeiro item
    var gaveta = document.querySelector('.cart-drawer__inner');
    if (gaveta) {
      // O carrinho ja lido serve: a gaveta e reconstruida varias vezes por
      // compra (ver `ligarOlhoGaveta`) e uma leitura de /cart.js por
      // reconstrucao era requisicao a toa.
      var pronto = ultimoCarrinho
        ? Promise.resolve(ultimoCarrinho)
        : pegarCarrinho();
      pronto.then(function (c) {
        var antigo = gaveta.querySelector('[data-vex-look]');
        if (!c.items || !c.items.length) {
          if (antigo) antigo.remove();
          return;
        }
        // assinatura do carrinho: se nao mudou, nao refaz nada
        var assinatura = c.items.map(function (i) { return i.product_id; }).sort().join(',');
        if (antigo && antigo.dataset.cesta === assinatura) return;
        // AS TRAVAS SAO VARIAVEIS, NAO ATRIBUTOS DO ELEMENTO. Antes a trava de
        // "ja estou buscando" morava em `gaveta.dataset.vexBuscando`, e a
        // `.cart-drawer__inner` e justamente o no que o tema refaz a cada
        // mudanca no carrinho -- a trava sumia (ou sobrevivia sem o bloco,
        // dependendo do morph) e o combo da gaveta ficava a sorte.
        if (lookGavetaEmVoo === assinatura) return;
        if (lookGavetaVazio === assinatura) return;
        lookGavetaEmVoo = assinatura;
        if (antigo) antigo.remove();

        return buscar(c.items[0].product_id, 6).then(function (ps) {
          lookGavetaEmVoo = null;
          var naCesta = c.items.map(function (i) { return i.product_id; });
          // sem sugerir o que ja esta no carrinho
          ps = ps.filter(function (p) { return naCesta.indexOf(p.id) === -1; }).slice(0, 4);
          // Sem sugestao para esta cesta: anota, para nao repetir a busca a
          // cada vez que a gaveta for redesenhada.
          if (!ps.length) { lookGavetaVazio = assinatura; return; }
          // Entre a lista de itens e o resumo. `cart-items-component` engloba
          // TUDO (itens + total + finalizar), entao inserir depois dele jogava
          // o bloco para o rodape da gaveta, fora da tela.
          var bloco = montarCarrossel(ps);
          bloco.dataset.cesta = assinatura;
          var resumo = gaveta.querySelector('.cart-drawer__summary');
          var itens = gaveta.querySelector('.cart-drawer__items');
          if (resumo && resumo.parentElement) {
            resumo.parentElement.insertBefore(bloco, resumo);
          } else if (itens && itens.parentElement) {
            itens.parentElement.insertBefore(bloco, itens.nextSibling);
          } else {
            gaveta.appendChild(bloco);
          }
        });
      }).catch(function () { lookGavetaEmVoo = null; });
    }
  }

  function buscar(idProduto, limite, intencao) {
    return fetch('/recommendations/products.json?product_id=' + idProduto +
                 '&limit=' + limite + '&intent=' + (intencao || 'complementary'))
      .then(function (r) { return r.json(); })
      .then(function (d) { return (d && d.products) || []; })
      .catch(function () { return []; });
  }

  // O COMBO SEMPRE COM 3 (pedido da cliente em 02/09).
  //
  // `intent=complementary` devolve o que a loja CUROU no app Search &
  // Discovery, produto a produto. Onde a curadoria tem menos de tres -- e em
  // boa parte do catalogo tem duas --, o combo aparecia com dois cards e o
  // titulo dizia "Choose 2 items". Nao e escolha de desenho, e lacuna de
  // cadastro aparecendo na vitrine.
  //
  // Entao a curadoria continua vindo PRIMEIRO, e o que falta e completado com
  // `intent=related`, que a Shopify calcula sozinha e nunca esta vazio numa
  // loja com catalogo. A ordem preserva a intencao do lojista: quem ele
  // escolheu abre a fileira.
  //
  // Se ainda assim nao houver tres, o combo entra com o que existe -- e
  // melhor que sumir.
  function buscarCombo(idProduto, minimo) {
    return buscar(idProduto, minimo, 'complementary').then(function (ps) {
      if (ps.length >= minimo) return ps.slice(0, minimo);

      // pede folga: parte dos relacionados costuma repetir os complementares
      return buscar(idProduto, minimo + 6, 'related').then(function (extras) {
        var vistos = ps.map(function (p) { return p.id; });
        vistos.push(idProduto);
        extras.forEach(function (p) {
          if (ps.length >= minimo) return;
          if (vistos.indexOf(p.id) !== -1) return;
          vistos.push(p.id);
          ps.push(p);
        });
        return ps;
      });
    });
  }

  /* ------------------------------------------------------------ ciclo */

  function encaixarConfianca() {
    var fonte = document.querySelector('.vex-trust-fonte');
    if (!fonte) return;
    var col = document.querySelector('.product-information');
    var secao = col && col.closest('.shopify-section');
    if (!secao || document.querySelector('main [data-vex-trust]')) return;
    var bloco = fonte.querySelector('[data-vex-trust]');
    if (!bloco) return;
    secao.parentElement.insertBefore(bloco, secao.nextSibling);
    fonte.remove();
  }

  // A grade de videos da pagina de produto NAO e posicionada aqui. Ela mora na
  // coluna do produto, entre o prazo de entrega e o "Buy more, save more", e
  // quem monta essa fila e o script de snippets/vex-promo.liquid, que ja espera
  // o combo chegar por fetch. A funcao que existia aqui mirava o mesmo ponto,
  // sorteava a ordem e ainda removia o involucro com o <style> da grade dentro
  // -- a faixa aparecia crua na pagina.

  // Marca a seção de perguntas frequentes (3+ sanfonas fora da coluna de
  // produto). Feito por script porque o id da seção muda por template e
  // depender dele quebraria se a cliente recriasse a seção.
  function marcarPerguntas() {
    document.querySelectorAll('.shopify-section').forEach(function (sec) {
      if (sec.classList.contains('vex-faq')) return;
      // A coluna do produto fica DENTRO da seção, não o contrário. Com
      // `closest` a seção principal do produto passava no filtro e recebia o
      // tratamento das perguntas, quebrando a página de venda inteira.
      if (sec.querySelector('.product-information')) return;
      if (sec.querySelector('product-form-component, .buy-buttons-block')) return;
      if (sec.querySelectorAll('details.details').length >= 3) {
        sec.classList.add('vex-faq');

        // "ainda com dúvida?" embaixo do título, que é onde a seção converte
        var painel = sec.querySelector('.layout-panel-flex');
        var coluna = painel && painel.firstElementChild;
        if (coluna && !coluna.querySelector('.vex-faq__ajuda')) {
          var ajuda = document.createElement('p');
          ajuda.className = 'vex-faq__ajuda';
          ajuda.innerHTML = 'Still not sure? <a href="' +
            (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') +
            'pages/contact">Talk to us</a>';
          coluna.appendChild(ajuda);
        }
      }
    });
  }

  // No celular o cabecalho aparecia SOLIDO no topo da home, virava
  // transparente ao rolar um pouco e voltava a solido depois -- exatamente o
  // inverso do esperado. A causa esta na logica de "sticky" do tema, que ja
  // considera o cabecalho fixado no primeiro paint.
  //
  // Em vez de disputar com essa logica, marco quando a pagina esta REALMENTE
  // no topo e deixo o CSS reafirmar ali as mesmas variaveis que o tema usa no
  // estado transparente. Nada de cor cravada na mao: foi assim que eu ja
  // acabei com texto branco sobre fundo branco.
  //
  // QUEM ROLA NAO E SEMPRE A JANELA. No Horizon 4.1.5, em telas de 990px para
  // cima, o base.css poe `overflow: hidden` no html e no body e passa a
  // rolagem para `.page-wrapper`. Lendo so `window.pageYOffset`, o valor ficava
  // preso em 0 no desktop, `data-vex-topo` nunca saia e o CABECALHO SEGUIA
  // TRANSPARENTE PAGINA ABAIXO. Aqui vale o maior dos dois deslocamentos, e a
  // escuta e nos dois -- serve ao tema antigo e ao 4.1.5.
  function marcarTopo() {
    var header = document.querySelector('header-component');
    if (!header || !header.hasAttribute('transparent')) return;
    var caixa = document.querySelector('.page-wrapper');

    function conferir() {
      var y = Math.max(
        window.pageYOffset || document.documentElement.scrollTop || 0,
        (caixa && caixa.scrollTop) || 0
      );
      if (y <= 4) header.setAttribute('data-vex-topo', '');
      else header.removeAttribute('data-vex-topo');
    }

    conferir();
    if (!header.dataset.vexTopoLigado) {
      header.dataset.vexTopoLigado = '1';
      // passive: nao segura a rolagem do dedo no celular
      window.addEventListener('scroll', conferir, { passive: true });
      window.addEventListener('resize', conferir, { passive: true });
      if (caixa) caixa.addEventListener('scroll', conferir, { passive: true });
    }
  }

  // As estrelas do topo da pagina de produto sao um bloco de HTML fixo, nao um
  // link -- clicar nelas nao fazia nada. Aqui elas passam a levar para as
  // avaliacoes la embaixo, com desconto da altura do cabecalho fixo (senao a
  // primeira linha fica escondida atras dele).
  function ligarEstrelas() {
    var bloco = document.querySelector('.review-rating-block');
    var alvo = document.querySelector('#judgeme_product_reviews');
    if (!bloco || !alvo || bloco.dataset.vexLigado) return;
    bloco.dataset.vexLigado = '1';

    bloco.classList.add('vex-estrelas-link');
    bloco.setAttribute('role', 'link');
    bloco.setAttribute('tabindex', '0');
    bloco.setAttribute('aria-label', 'Read the reviews');

    function ir() {
      var header = document.querySelector('header-component');
      var folga = (header ? header.offsetHeight : 0) + 16;
      var y = alvo.getBoundingClientRect().top + window.pageYOffset - folga;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }

    bloco.addEventListener('click', ir);
    // teclado: quem navega por Tab tem que conseguir acionar tambem
    bloco.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); ir(); }
    });
  }

  // (8 do feedback) O bloco do topo dizia "5.0 / 5.0 based on 100+ reviews",
  // texto fixo escrito a mao, enquanto o widget do Judge.me logo abaixo dizia
  // "4.91 · 11 reviews". Como as estrelas agora LEVAM ate esse widget, o
  // cliente via os dois numeros em sequencia -- era essa contradicao que a
  // cliente leu como "pouca credibilidade", nao o tamanho da fonte.
  // Aqui o topo passa a mostrar o numero real, lido do proprio Judge.me.
  function notaReal() {
    var bloco = document.querySelector('.review-rating-block');
    if (!bloco || bloco.dataset.vexNota) return;

    var w = document.querySelector('.jdgm-rev-widg[data-average-rating]');
    if (!w) return;   // o widget carrega depois; `atualizar()` tenta de novo

    var media = parseFloat(w.getAttribute('data-average-rating'));
    var qtd = parseInt(w.getAttribute('data-number-of-reviews'), 10);
    if (!media || !qtd) return;

    bloco.dataset.vexNota = '1';
    var alvo = bloco.querySelector('span:last-child') || bloco;
    alvo.innerHTML = '<strong>' + media.toFixed(1) + ' / 5.0</strong> based on <strong>' +
                     qtd + '</strong> review' + (qtd === 1 ? '' : 's');
  }

  // A regua "Buy more, save more" era inserida ACIMA do botao de compra pelo
  // script do theme.liquid, empurrando o "Add to cart" para baixo. Desde 01/09
  // ela vive DENTRO do combo (ver `montarBundle`), entao aqui so resta:
  //   - se ela ja esta dentro do combo, nao mexer;
  //   - se o combo ainda nao existe (produto sem recomendacao), deixar a regua
  //     abaixo do botao, que e a ordem certa da coluna.
  function arrumarPromo() {
    var promo = document.querySelector('.vex-promo--produto');
    if (!promo || promo.closest('.vex-bundle')) return;

    var compra = document.querySelector('.buy-buttons-block, .product-form-buttons');
    if (!compra) return;
    // ja esta depois do botao? nada a fazer
    if (!(promo.compareDocumentPosition(compra) & Node.DOCUMENT_POSITION_FOLLOWING)) return;

    var ancora = compra;
    var vizinho = compra.nextElementSibling;
    for (var i = 0; i < 3 && vizinho; i++) {
      if (/deliver|shipping|exchange|arrives|frete/i.test(vizinho.textContent || '')) ancora = vizinho;
      vizinho = vizinho.nextElementSibling;
    }
    ancora.parentElement.insertBefore(promo, ancora.nextSibling);
  }

  function atualizar() {
    marcarTopo();
    arrumarPromo();
    ligarEstrelas();
    notaReal();
    marcarPerguntas();
    encaixarBarra();
    encaixarLook();
    encaixarConfianca();
    ligarOlhoGaveta();
    pegarCarrinho().then(function (c) {
      ultimoCarrinho = c;
      pintarBarra(c);
      enfeitarFinalizar(c);
      // De novo, agora com o carrinho fresco: a chamada la de cima roda antes
      // desta leitura e, numa adicao, enxerga a cesta ANTERIOR. As travas de
      // assinatura fazem a segunda chamada nao custar nada quando nada mudou.
      encaixarLook();
    }).catch(function () {});
  }

  // o tema mexe no carrinho sem recarregar a pagina
  var fetchOriginal = window.fetch;
  window.fetch = function () {
    var p = fetchOriginal.apply(this, arguments);
    try {
      var url = String(arguments[0] && arguments[0].url ? arguments[0].url : arguments[0]);
      if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { setTimeout(atualizar, 120); });
    } catch (e) {}
    return p;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', atualizar);
  } else { atualizar(); }
  window.addEventListener('load', function () { atualizar(); });
  // a gaveta so existe no DOM depois de aberta em alguns casos
  document.addEventListener('click', function () { setTimeout(atualizar, 350); }, true);

  // Evento padrao da Shopify, disparado por QUALQUER caminho que mexa no
  // carrinho -- botao do tema, quick add, seletor de quantidade e o nosso
  // combo. Esperar a promessa do proprio evento e o unico jeito de rodar
  // DEPOIS do morph sem cravar um numero de milissegundos.
  document.addEventListener('shopify:cart:lines-update', function (ev) {
    var espera = ev && ev.promise && typeof ev.promise.then === 'function'
      ? ev.promise
      : null;
    if (!espera) { setTimeout(atualizar, 80); return; }
    espera.then(function () { atualizar(); }).catch(function () {});
  });
})();
